import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { getItemText, getUpdateInfo } from './history-helpers';
import { getDateAndTime } from '../../../../lib/utils';
import { tableComponent } from '../../../elements/historyTable';
import { getDisplayUserName } from '../../../../lib/userUtils';

const SingleHistoryElement = ({ item, users, environments, statuses, releases, jobs }) => {
  if (!item || item.length === 0) return null;

  const createdBy = getDisplayUserName(item[0]?.test_cycle_history_user);
  const itemData = getItemText(item[0]);
  const creationDate = getDateAndTime(item[0]?.created_at, users, statuses);

  return (
    <Row>
  <Col>
    <p>
      <strong>{createdBy}</strong> {itemData} - {creationDate}
    </p>
    {item?.length === 1 ? (
      ['UPDATED_TEST_CYCLE', 'UPDATED_TEST_CASE'].includes(item[0].event_type) ? (
        tableComponent(getUpdateInfo(item[0], users, environments, statuses, releases, jobs))
      ) : (
        <React.Fragment>{getUpdateInfo(item[0], users, environments, statuses, releases, jobs)}</React.Fragment>
      )
    ) : item?.length > 1 && ['ADDED_TEST_CASE', 'REMOVED_TEST_CASE', 'ADDED_ATTACHMENT_CYCLE', 'REMOVED_ATTACHMENT_CYCLE', 'CREATED_ITERATION', 'REMOVED_EXECUTION', 'EXECUTION_STATUS_UPDATE'].includes(item[0].event_type) ? (
      item.map((history, index) => (
        <React.Fragment key={history.id || index}>{getUpdateInfo(history, users, environments, statuses, releases, jobs)}</React.Fragment>
      ))
    ) : (
      tableComponent(
        item.map((history, index) => (
          <React.Fragment key={history.id || index}>{getUpdateInfo(history, users, environments, statuses, releases, jobs)}</React.Fragment>
        ))
      )
    )}
  </Col>
</Row>

  );
};

export default SingleHistoryElement;
